"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgMobile(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M15.979 0a2.815 2.815 0 012.808 2.809V21.19A2.815 2.815 0 0115.98 24h-8.17A2.815 2.815 0 015 21.191V2.81A2.815 2.815 0 017.809 0zm0 1.532h-8.17c-.7 0-1.277.576-1.277 1.277V21.19c0 .7.576 1.277 1.277 1.277h8.17c.7 0 1.276-.576 1.276-1.277V2.81c0-.7-.576-1.277-1.276-1.277zm-4.085 17.617a1.021 1.021 0 110 2.042 1.021 1.021 0 010-2.042zm1.02-16.085a.766.766 0 01.105 1.525l-.104.007h-2.043a.766.766 0 01-.104-1.525l.104-.007h2.043z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgMobile;
exports.default = _default;